<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="handleNavigateBack()">
    <ng-container *ngIf="hasAccess">
      <ng-container *ngIf="isMobile">
        <div class="flashlight-button content-default">
          <ng-container *ngIf="!flashEnabled; then flashOnTemplate else flashOffTemplate"></ng-container>
          <ng-template #flashOnTemplate>
            <button mat-mini-fab (click)="turnOnFlashLight()">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-torch-on"></div>
            </button>
          </ng-template>
          <ng-template #flashOffTemplate>
            <button mat-mini-fab (click)="turnOffFlashLight()">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-torch-off"></div>
            </button>
          </ng-template>
        </div>
      </ng-container>
    </ng-container>
  </ya-subheader>
  <div class="ya-page-content">
    <div class="content--top content-default">
      <div class="scan-content content-background--mix">
        <div class="inline-icon qrcode_icon" inlineSVG="shop-icons.svg#ya-hypersoft-qr"></div>
        <div class="content-description">
          <h3 langkey="phCoupon_Redeem_Scan_Title"> </h3>
        </div>
      </div>
    </div>
    <div class="qrcode-frame-container">
      <div class="frame--left content-default">
        <div class="qrcode-side-frame content-background--mix"></div>
      </div>
      <div class="qrcode-frame">
        <div class="aspect-equal-ratio-box">
          <div class="aspect-ratio-box-inside">
            <ng-container *ngIf="hasAccess; then cameraAccessTemplate else cameraNotAccessTemplate"></ng-container>
            <ng-template #cameraAccessTemplate>
              <div class="camera-frame" id="camera-frame">
                <zxing-scanner *ngIf=" !isMobile && zXingScanner" [formats]="['QR_CODE']"
                  (camerasNotFound)="onCamerasnotfound($event)" (camerasFound)="onCamerasFound($event)"
                  (scanError)="scanErrorHandler($event)" (permissionResponse)="onPermissionResponse($event)"
                  (scanFailure)="scanFailureHandler($event)" (scanComplete)="scanCompleteHandler($event)">
                </zxing-scanner>
              </div>
            </ng-template>
            <ng-template #cameraNotAccessTemplate>
              <div class="camera-Container ya-page-content--webshop">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-no_camera"></div>
                <p langkey="phQRCode_Access_Denied_Text"></p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="frame--right content-default">
        <div class="qrcode-side-frame content-background--mix"></div>
      </div>
    </div>
    <div class="content--bottom content-default">
      <div class="scan-content content-background--mix">
        <div class="ya-webshop-button-container coupon-btn--continue">
          <button mat-flat-button (click)="cancelScan()">
            <span langkey="phCoupon_Redeem_Scan_Btn_Text_Cancel"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>